import React, { FC } from 'react';
import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';
import styles from './index.module.scss';
import { MediaListProps, MediafileType } from '../../types';

interface MediaListItemIconsPlayTimeProps {
  playTime?: MediafileType['playtime'];
  timezone?: MediaListProps['timezone'];
}

const getFormattedPlaytime = (playtime: string, timezone?: string | null) => {
  if (timezone) {
    const time = playtime.split('T');
    const times = time[1].split(':');
    return `${times[0]}:${times[1]}`;
  }

  return DateUtils.getFormatDateFrom(new Date(playtime), 'HH:mm');
};

const MediaListItemIconsPlayTime: FC<MediaListItemIconsPlayTimeProps> = (props) => {
  const { playTime, timezone } = props;
  const time = playTime && getFormattedPlaytime(playTime, timezone);

  if (!playTime) {
    return null;
  }

  return <span className={styles.Time}>{time}</span>;
};

export default MediaListItemIconsPlayTime;
